module.exports = __webpack_public_path__ + "img/Qualityserve-imgb.40db5ec4.png";